var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observe } from "mobx";
import { observer } from "mobx-react";
import { DeviceDetect } from "sb-resp-utils";
import { Transition } from "react-transition-group";
import gsap from "gsap";
import { Icon, Loader } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import { ButtonModifiers, OddsModifiers, BetStatus } from "../../enums";
import { excludeLetters, getSlideAnimationVars } from "../../helpers";
let YourbetMiniBetSlip = class YourbetMiniBetSlip extends React.Component {
    constructor(props) {
        super(props);
        this.deviceDetect = DeviceDetect.getInstance();
        // setup dictionary
        this.dict = this.props.dict;
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        };
        this.stakeInput = React.createRef();
        this.disposeStakeValue = observe(this.state.dataProvider, "stakeValue", o => {
            if (this.stakeInput.current) {
                this.stakeInput.current.value = o.newValue;
            }
        });
    }
    componentDidMount() {
        this.state.dataProvider.changeVisibility(true);
    }
    componentWillUnmount() {
        this.disposeStakeValue();
        this.state.dataProvider.changeVisibility(false);
    }
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderSummary() {
        return (React.createElement("div", { className: "rj-yourbet__main-slide rj-yourbet__main-slide--center" },
            this.state.dataProvider.purchases.map(p => (this.state.dataProvider.isAccepted &&
                React.createElement("div", { className: "rj-yourbet__selections", key: `ticket-${p.id}` },
                    React.createElement(CMP.Summary, { txt_1: this.dict.Stake, txt_2: p.stake || "", odds: p.odds || "", returnTxt: this.dict.Return, returnValue: p.return || "", oddsModf: OddsModifiers.accepted, dataUat: "bet-slip-selection-odds" }),
                    React.createElement(CMP.Market, { title: this.dict.TicketNumber, market: p.id })))),
            !this.state.dataProvider.selectionsCount && React.createElement(CMP.EmptyMsg, { label: this.dict.EmtyMsg })));
    }
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderFooterMobile() {
        return (React.createElement("div", { className: "rj-yourbet__section rj-yourbet__footer" }, this.renderFooter()));
    }
    renderFooter() {
        const leftComponentStake = this.state.dataProvider.leftComponentStake;
        const leftComponentButton = this.state.dataProvider.leftComponentButton;
        const rightComp = this.state.dataProvider.rightComponent;
        const stakeClassName = leftComponentStake.buttons.left.disabled &&
            leftComponentStake.buttons.right.disabled &&
            this.state.dataProvider.isChecked ?
            "rj-yourbet__stake rj-yourbet__stake--disable-free-bet" :
            "rj-yourbet__stake";
        return React.createElement(React.Fragment, null,
            leftComponentButton ?
                React.createElement(CMP.Button, Object.assign({}, leftComponentButton), leftComponentButton.label)
                :
                    React.createElement("div", { className: stakeClassName },
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, dataUatButton: leftComponentStake.buttons.dataUatButton, dataUatInner: leftComponentStake.buttons.dataUatInner, handler: leftComponentStake.buttons.left.handler, disabled: leftComponentStake.buttons.left.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-minus" })),
                        React.createElement(CMP.StakeInput, { provider: this.state.dataProvider, handler: leftComponentStake.handler, inputHandler: excludeLetters, type: this.props.stakeInputType, disabled: leftComponentStake.buttons.left.disabled && leftComponentStake.buttons.right.disabled }),
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, dataUatButton: leftComponentStake.buttons.dataUatButton, dataUatInner: leftComponentStake.buttons.dataUatInner, handler: leftComponentStake.buttons.right.handler, disabled: leftComponentStake.buttons.right.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-plus" }))),
            React.createElement(CMP.Button, { modifier: rightComp.modifier, handler: rightComp.handler, disabled: rightComp.disabled, dataUatButton: rightComp.dataUatButton, dataUatInner: rightComp.dataUatInner }, rightComp.label));
    }
    renderFooterDesktop() {
        return (React.createElement("div", { className: "rj-yourbet__section rj-yourbet__footer" },
            this.renderFooter(),
            (this.state.dataProvider.betStatus === BetStatus.NewOffer || this.state.dataProvider.purchases.some(p => p.shouldAcceptNewOdds))
                && React.createElement(CMP.Button, { modifier: "cancel", dataUatButton: "button-bet-slip-new-offer-cancel", dataUatInner: "bet-slip-new-offer-cancel", handler: this.props.dataProvider.cancelHandler }, this.dict.Cancel)));
    }
    renderSelectionsMobile() {
        return React.createElement("div", { className: "rj-yourbet__main-slide" },
            React.createElement("div", { className: "rj-yourbet__selections" },
                this.state.dataProvider.selectionsCount > 0 && !this.state.dataProvider.isAccepted && this.renderSelectionsSummary(),
                React.createElement(CMP.HorizontalSelections, null, !this.state.dataProvider.isAccepted && this.state.dataProvider.provider.selections.map((sel, i) => (React.createElement(CMP.Market, { key: sel.id, title: sel.name, market: sel.eventType, handler: () => { this.state.dataProvider.removeSelection(sel.id); }, isSuspended: sel.suspended, suspendedTxt: sel.suspended ? this.dict.Danger : "" })))),
                React.createElement(CMP.FreeBetSection, Object.assign({}, this.state.dataProvider.buildFreeBetSectionProps))));
    }
    renderSelectionsDesktop() {
        var _a;
        const freeBetProps = this.state.dataProvider.buildFreeBetSectionProps;
        return React.createElement("div", { className: "rj-yourbet__main-slide" }, !this.state.dataProvider.isAccepted && React.createElement("div", { className: "rj-yourbet__selections" },
            this.state.dataProvider.selectionsCount > 0 && this.renderSelectionsSummary(),
            React.createElement("div", { className: "rj-yourbet__selection-list", "data-uat": "id-bets-selections" }, this.state.dataProvider.provider.selections.map((sel, i) => (React.createElement(CMP.Market, { key: sel.id, title: sel.name, market: sel.eventType, handler: () => { this.state.dataProvider.removeSelection(sel.id); }, isSuspended: sel.suspended, suspendedTxt: sel.suspended ? this.dict.Danger : "" })))),
            ((_a = freeBetProps === null || freeBetProps === void 0 ? void 0 : freeBetProps.freeBets) === null || _a === void 0 ? void 0 : _a.length) > 0 && React.createElement(CMP.FreeBetDesktop, Object.assign({}, freeBetProps))));
    }
    renderSelectionsSummary() {
        return React.createElement(React.Fragment, null, this.state.dataProvider.purchases.map(p => (React.createElement(CMP.Summary, { key: p.id, txt_1: this.state.dataProvider.selectionsCount, txt_2: this.dict.SelectionLabel, odds: p.odds || "", returnTxt: this.dict.Return, returnValue: p.return || "", oddsModf: p.oddsUpdated ? OddsModifiers.changed : OddsModifiers.default, dataUat: p.oddsUpdated ? "bet-slip-odds-changed" : "bet-odds" }))));
    }
    renderDesktop() {
        const hasSelections = !this.state.dataProvider.isAccepted ? " rj-yourbet__main--has-selections" : "";
        const yourBetClass = `rj-yourbet ${this.state.dataProvider.isWaiting ? "rj-yourbet--waiting" : ""}`;
        return React.createElement("div", { className: "rj-yourbet__desktop-wrapper" },
            React.createElement("h3", { className: "rj-yourbet__desktop-header" }, this.dict.YourBet),
            this.state.dataProvider.purchases.map(p => (this.state.dataProvider.messages(p.id).map((x, y) => (React.createElement(CMP.MessageDesktop, { key: `${x.id}-${y}`, modifier: x.modifier, label: x.label, type: x.type }))))),
            this.state.dataProvider.selectionsCount
                ? React.createElement("div", { className: yourBetClass },
                    React.createElement("div", { className: `rj-yourbet__main${hasSelections}` },
                        this.renderSummary(),
                        this.renderSelectionsDesktop()),
                    this.renderFooterDesktop(),
                    this.state.dataProvider.isWaiting && React.createElement("div", { className: "rj-yourbet__loader" },
                        React.createElement(Loader, null)))
                : React.createElement(CMP.PlaceholderDesktop, { description: this.dict.EmtyMsgDesktop, firstBoxContent: "1", secondBoxContent: "2" }));
    }
    renderMobile() {
        const hasSelections = this.state.dataProvider.selectionsCount && !this.state.dataProvider.isAccepted ? " rj-yourbet__main--has-selections" : "";
        // TODO Use a setting to enable or disable the slide down animation on mount>
        return (React.createElement(Transition, { timeout: 1000, in: this.state.dataProvider.isShown, addEndListener: (node, done) => {
                const { from, to } = getSlideAnimationVars({
                    shouldShow: this.state.dataProvider.isShown,
                    duration: 0.2,
                    onComplete: done
                });
                gsap.fromTo(node, from, to);
            } },
            React.createElement("div", { className: "rj-yourbet" },
                this.state.dataProvider.purchases.map(p => (this.state.dataProvider.messages(p.id).map((x, y) => (React.createElement(CMP.Message, { key: `${x.id}-${y}`, modifier: x.modifier, label: x.label, type: x.type, handler: x.handler }))))),
                React.createElement("div", { className: `rj-yourbet__main${hasSelections}` },
                    this.renderSummary(),
                    this.renderSelectionsMobile()),
                this.renderFooterMobile(),
                this.state.dataProvider.isWaiting && React.createElement("div", { className: "rj-yourbet__loader" },
                    React.createElement(Loader, null)))));
    }
    render() {
        return this.deviceDetect.isDesktop ? this.renderDesktop() : this.renderMobile();
    }
};
YourbetMiniBetSlip = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], YourbetMiniBetSlip);
export { YourbetMiniBetSlip };
//# sourceMappingURL=YourbetMiniBetSlip.js.map